import { Button, Col, Drawer, FloatButton, Image, Row } from 'antd';
import React from 'react';
import { BsChatDotsFill } from 'react-icons/bs';

// ICONS
import { IoMenuSharp } from 'react-icons/io5';
import { Link } from 'react-router-dom';

// IMG
import logo from '../../assets/img/logo/jurisvip-transparente.png';

// CSS
import './styles.css';

class NavbarComponent extends React.Component {
  state = {
    menu: false,
  };

  onClick = () => {
    window.document.getElementById('web-content').scrollTo(0, 0);
  };

  onMenu = () => {
    this.setState({ menu: !this.state.menu });
  };

  render = () => {
    return (
      <Row align={'middle'} className="navbar-content" gutter={[8, 8]}>
        <Col md={2} xs={6}>
          <Link to="/">
            <Image className="navbar-logo" preview={false} src={logo} />
          </Link>
        </Col>
        <Col md={22} xs={0}>
          <Row align={'middle'} justify={'end'}>
            <Link to="/">
              <Button
                className="btn-link navbar-link"
                type=" onClick={this.onClick}link"
              >
                Home
              </Button>
            </Link>
            <Link to="/quemsomos">
              <Button
                className="btn-link navbar-link"
                onClick={this.onClick}
                type="link"
              >
                Quem Somos
              </Button>
            </Link>
            <Link to="/planos">
              <Button
                className="btn-link navbar-link"
                onClick={this.onClick}
                type="link"
              >
                Planos
              </Button>
            </Link>
            <Link to="/faq">
              <Button
                className="btn-link navbar-link"
                onClick={this.onClick}
                type="link"
              >
                FAQ
              </Button>
            </Link>
            <Link to="/contato">
              <Button
                className="btn-link navbar-link"
                onClick={this.onClick}
                type="link"
              >
                Contato
              </Button>
            </Link>
            <Link to="/cadastrese">
              <Button
                className="btn-link navbar-link"
                onClick={this.onClick}
                type="link"
              >
                Cadastre-se
              </Button>
            </Link>
            <Link to="/login">
              <Button
                className="btn-primary navbar-button"
                onClick={this.onClick}
                size="large"
                type="primary"
              >
                Entrar
              </Button>
            </Link>
          </Row>
        </Col>
        <Col md={0} xs={18}>
          <Row align={'middle'} justify={'end'}>
            <Link to="/login">
              <Button className="btn-primary navbar-button" type="primary">
                Entrar
              </Button>
            </Link>
            <Button
              className="btn-link navbar-link"
              onClick={this.onMenu}
              shape="circle"
              style={{ marginLeft: 10 }}
              type="link"
            >
              <IoMenuSharp size={20} />
            </Button>
          </Row>
        </Col>
        <Drawer
          closable={false}
          onClose={this.onMenu}
          open={this.state.menu}
          width={250}
        >
          <Row gutter={[8, 8]}>
            <Col span={24}>
              <Link to="/">
                <Button
                  block
                  className="btn-link navbar-link"
                  onClick={this.onMenu}
                  type="link"
                >
                  Home
                </Button>
              </Link>
            </Col>
            <Col span={24}>
              <Link to="/quemsomos">
                <Button
                  block
                  className="btn-link navbar-link"
                  onClick={this.onMenu}
                  type="link"
                >
                  Quem Somos
                </Button>
              </Link>
            </Col>
            <Col span={24}>
              <Link to="/planos">
                <Button
                  block
                  className="btn-link navbar-link"
                  onClick={this.onMenu}
                  type="link"
                >
                  Planos
                </Button>
              </Link>
            </Col>
            <Col span={24}>
              <Link to="/faq">
                <Button
                  block
                  className="btn-link navbar-link"
                  onClick={this.onMenu}
                  type="link"
                >
                  FAQ
                </Button>
              </Link>
            </Col>
            <Col span={24}>
              <Link to="/contato">
                <Button
                  block
                  className="btn-link navbar-link"
                  onClick={this.onMenu}
                  type="link"
                >
                  Contato
                </Button>
              </Link>
            </Col>
            <Col span={24}>
              <Link to="/cadastrese">
                <Button
                  block
                  className="btn-link navbar-link"
                  onClick={this.onMenu}
                  type="link"
                >
                  Cadastre-se
                </Button>
              </Link>
            </Col>
          </Row>
        </Drawer>
        <FloatButton
          className="navbar-fabbutton"
          icon={<BsChatDotsFill color="#FFFF" />}
        />
      </Row>
    );
  };
}

export default NavbarComponent;
